import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { NotificationApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class NotificationApiModule {
    public static forRoot(configurationFactory: () => NotificationApiConfiguration): ModuleWithProviders<NotificationApiModule> {
        return {
            ngModule: NotificationApiModule,
            providers: [ { provide: NotificationApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: NotificationApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('NotificationApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
